<template lang="pug">
  div.gauge-chart
    div.title 危机严重性
    div#gaugeChart
    p {{gauge.crisisLevelZh}}风险
    div._event_star(v-html="star")
</template>

<script>
import echarts from 'echarts'
import { getStar } from '../config/config'
export default {
  name: 'GaugeChart',
  computed: {
    gauge () {
      return this.$store.state.event.gauge
    },
    star () {
      return getStar(this.$store.state.event.gauge.crisisLevel)
    }
  },
  watch: {
    gauge: {
      deep: true,
      handler () {
        this.init()
      }
    }
  },
  methods: {
    init () {
      let dataArr = this.gauge.value
      let colorSet = {
        color: '#f87653'
      }
      let option = {
        tooltip: {
          formatter: '{a} <br/>{b} : {c}%'
        },
        series: [
          {
            name: '指针背景',
            color: '#eeeeee',
            type: 'pie',
            radius: '17%',
            hoverAnimation: false,
            silent: true,
            label: {
              show: false
            },
            tooltip: {
              show: false
            },
            animation: false,
            data: [{ value: 100, name: '' }],
            z: 1
          },
          {
            name: '内部进度条',
            type: 'gauge',
            // center: ['20%', '50%'],
            radius: '100%',
            splitNumber: 10,
            tooltip: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: [
                  [dataArr / 100, colorSet.color],
                  [1, '#e8ebf1']
                ],
                width: 8
              }
            },
            axisLabel: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            itemStyle: {
              color: '#f87653'
            },
            detail: {
              show: false,
              formatter: function (value) {
                if (value !== 0) {
                  let num = Math.round(value)
                  return parseInt(num).toFixed(0) + '%'
                } else {
                  return 0
                }
              },
              offsetCenter: [0, 82],
              textStyle: {
                padding: [0, 0, 0, 0],
                fontSize: 18,
                fontWeight: '700',
                color: '#f87653'
              }
            },
            title: {
              show: true,
              offsetCenter: [0, 46], // x, y，单位px
              textStyle: {
                color: '#fff',
                fontSize: 14, // 表盘上的标题文字大小
                fontWeight: 400,
                fontFamily: 'PingFangSC'
              }
            },
            data: [{
              name: 'title',
              value: dataArr
            }],
            pointer: {
              show: true,
              length: '50%',
              radius: '15%',
              width: 8
            },
            animationDuration: 4000,
            z: 2
          },
          {
            name: '外部刻度',
            type: 'gauge',
            //  center: ['20%', '50%'],
            radius: '85%',
            min: 0, // 最小刻度
            max: 100, // 最大刻度
            splitNumber: 10, // 刻度数量
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: [
                  [1, 'rgba(0,0,0,0)']
                ]
              }
            }, // 仪表盘轴线
            axisTick: {
              show: true,
              splitNumber: 7,
              lineStyle: {
                color: '#ccc', // 用颜色渐变函数不起作用
                width: 1
              },
              length: 5
            }, // 刻度样式
            splitLine: {
              show: true,
              length: 10,
              lineStyle: {
                color: '#ccc' // 用颜色渐变函数不起作用
              }
            }, // 分隔线样式
            detail: {
              show: false
            },
            pointer: {
              show: false
            },
            z: 3
          },
          {
            name: '指针圆心',
            color: '#fff',
            type: 'pie',
            radius: '3%',
            hoverAnimation: false,
            silent: true,
            label: {
              show: false
            },
            tooltip: {
              show: false
            },
            animation: false,
            data: [{ value: 100, name: '' }],
            z: 4
          }
        ]
      }
      let chart = echarts.init(document.getElementById('gaugeChart'))
      chart.setOption(option)
      window.addEventListener('resize', () => {
        chart.resize()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.gauge-chart {
  padding: 0 20px;
  height: 300px;
  flex: 1;

  .title {
    margin-top: 24px;
    text-align: center;
    color: #333;
  }

  #gaugeChart {
    margin-top: 10px;
    height: 180px;
    display: flex;
    justify-content: center;
  }

  p {
    text-align: center;
    color: #f87653;
    font-size: 12px;
  }
}
</style>
<style lang="scss">
._event_star {
  margin-top: 10px;
  text-align: center;

  i {
    margin: 0 3px;

    &.fa-star {
      color: #f87653;
    }

    &.fa-star-o {
      color: #cccccc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventGeneral/GaugeChart.vue